import script from "./Occupational-Pension-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Occupational-Pension-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./Occupational-Pension-Questionnaire-Main.vue?vue&type=style&index=0&id=68ae11ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ae11ba"]])

export default __exports__